// extracted by mini-css-extract-plugin
module.exports = {"search__dropdown":"topics-list_search__dropdown__150vp","topic":"topics-list_topic__3t8CJ"};